import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { getWhatsAppLink } from '../../utils/whatsapp';
export function FinalCTA() {
  return <section className="bg-arena flex flex-col items-center justify-center text-center px-6 md:px-20 pt-[64px] md:pt-[80px] pb-[64px] md:pb-[80px]" data-id="element-131" data-mp="qae7000e64ds">
      <motion.div initial={{
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.2
    }} transition={{
      duration: 0.4,
      ease: 'easeOut'
    }} className="flex flex-col items-center max-w-[680px]" data-id="element-132" data-mp="lcmfv87kmman">
        <h2 className="font-display text-[36px] md:text-[52px] font-bold text-carbon leading-[1.1] tracking-tightest mb-4 max-w-[640px]" data-id="element-133" data-mp="2jsb173nwak5">
          ¿Qué parte de tu operación debería dejar de hacerse manualmente?
        </h2>

        <p className="font-body text-[18px] md:text-[20px] text-carbon/55 max-w-[480px] mb-10" data-id="element-134" data-mp="361aaaq5dc98y">
          Cuéntanos cómo funciona hoy tu proceso y diseñamos el sistema que
          podría automatizarlo.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-3" data-id="element-135" data-mp="33bq4allrlnqd">
          <a href={getWhatsAppLink('Hola, equipo de Origen Studio. Quiero construir mi sistema digital.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-verde text-arena font-display font-semibold text-[15px] md:text-[16px] px-[32px] py-[16px] rounded-[6px] hover:bg-verde-hover hover:-translate-y-[1px] hover:shadow-cta active:translate-y-0 transition-all duration-200" data-id="element-136" data-mp="385cem74ghfj0">
            Construir mi sistema <ArrowRight size={18} className="ml-2" data-id="element-137" data-mp="4o2oq5zny40n" />
          </a>
          <a href={getWhatsAppLink('Hola, equipo de Origen Studio. Cuéntenme cómo puedo automatizar mi empresa.')} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center bg-transparent text-carbon border border-carbon/20 font-display font-semibold text-[15px] md:text-[16px] px-[32px] py-[16px] rounded-[6px] hover:border-carbon/40 hover:bg-carbon/5 transition-all duration-200" data-id="element-138" data-mp="4nkm8rmeqtka">
            Hablar con ORIGEN <ArrowRight size={18} className="ml-2" data-id="element-139" data-mp="3l1o3j7fajg9j" />
          </a>
        </div>

        <p className="font-body text-[13px] text-carbon/40 mt-5" data-id="element-140" data-mp="2xe7i8oqg0ls3">
          Sin compromiso. Solo una conversación sobre tu proceso.
        </p>

        <div className="mt-16 flex flex-col items-center" data-id="element-141" data-mp="37497vkyg2c94">
          <div className="w-[60px] h-px bg-carbon/15 mb-4" data-id="element-142" data-mp="375u2fakrdv6z" />
          <span className="font-body text-[12px] text-carbon/30" data-id="element-143" data-mp="32bzl2dsmlsb2">
            Origen Studio · Colombia · 2026
          </span>
        </div>
      </motion.div>
    </section>;
}